module.exports = __webpack_public_path__ + "assets/img/nav-feature-73dbe98d.png";